import { Chip } from "@mui/material";
import {
	BooleanField,
	BooleanInput,
	CreateButton,
	Datagrid,
	DateField,
	DeleteButton,
	EditButton,
	EmailField,
	ExportButton,
	FilterButton,
	List,
	ShowButton,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { SoftDeleteToggle } from "@/components/SoftDeleteToggle";

const partnerFilters = [
	<TextInput key="name" label="Name" source="name" alwaysOn />,
	<TextInput key="ownerEmail" label="Owner Email" source="ownerEmail" />,
	<BooleanInput
		key="payoutEnabled"
		label="Payout Enabled"
		source="payoutEnabled"
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<CreateButton />
		<ExportButton />
		<SoftDeleteToggle />
	</TopToolbar>
);

const DeletedChip = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;
	return <Chip label="Deleted" size="small" color="error" />;
};

export const PartnerList = () => (
	<List
		filters={partnerFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid rowClick="show">
			<TextField source="name" />
			<EmailField source="ownerEmail" label="Owner" />
			<BooleanField source="payoutEnabled" label="Payout Enabled" />
			<TextField
				source="stripeAccountId"
				label="Stripe Account"
				emptyText="-"
			/>
			<DateField source="createdAt" label="Created" />
			<DeletedChip />
			<EditButton />
			<ShowButton />
			<DeleteButton />
		</Datagrid>
	</List>
);
